import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Input } from '../Input';
import { Box, useMediaQuery } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { Download, TuneOutlined } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles'

interface Props {
  columns: GridColDef[];
  rows: any[];
  onCellClick?: (item: any) => void;
  handleBlur?: any;
  handleChange?: any;
  onClickFilter?: any;
  showFilter?: boolean;
  values?: any;
  onClickToXlsx?: any;
  showButtonToXlsx?: boolean;
  total_sum?: number;
  openFilter?: any;
  height?: string;
  hideFooter?: boolean;
}

export default function DataTable({
  columns,
  rows,
  onCellClick,
  handleBlur,
  handleChange,
  values,
  showFilter,
  onClickFilter,
  onClickToXlsx,
  showButtonToXlsx,
  openFilter,
  height = '75vh',
  hideFooter = false
}: Props) {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  return (
    <div style={{ height: height, background: 'white' }}>
      <Box className={'flex flex-row items-center justify-between'}>
        {showFilter && (
          <form
            className='flex w-full flex-col items-center justify-end lg:flex-row'
            onSubmit={onClickFilter}
          >
            <Box className='mr-2'>
              <Input
                label={'Buscar'}
                value={values?.search}
                name={'search'}
                placeholder={'ID, Empresa'}
                handleBlur={handleBlur}
                handleChange={handleChange}
              />
            </Box>
            <Box className='pt-4 lg:pt-0'>
              {showButtonToXlsx && (
                <IconButton onClick={onClickToXlsx}>
                  <Download />
                </IconButton>
              )}
              <IconButton onClick={openFilter}>
                <TuneOutlined />
              </IconButton>
            </Box>
          </form>
        )}
      </Box>

      <DataGrid
        disableColumnMenu={true}
        disableColumnFilter={true}
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 100 },
          },
        }}
        pageSizeOptions={[]}
        checkboxSelection={false}
        onRowClick={(item) => (onCellClick ? onCellClick(item) : '')}
        hideFooter={hideFooter}
        columnBufferPx={isMediumScreen ? 2 : 5}
        sx={{ cursor: 'pointer' }}
      />
    </div>
  );
}
